import request from '../services/request';

export function getAnalytics(data) {
  return request({
    url: `/dashboard/analytics`,
    method: 'POST',
    data,
  });
}
